import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
export default (data, title) => {
  const [isCheckedMap, setIsCheckedMap] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const baseURL = process.env.REACT_APP_BASE_URL;
  useEffect(() => {
    if (data?.length) {
      const initialChecked = {};
      data.forEach((item) => {
        initialChecked[item.id] = item.is_active;
      });
      setIsCheckedMap(initialChecked);
    }
  }, [data]);
  const JobIn_ActiveMutation = useMutation({
    mutationFn: async (JobData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/update-job-status`,
        JobData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: async (data) => {
      setLoading(false);
      queryClient.invalidateQueries(["jobsListing"]);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      setLoading(false);
    },
  });

  const handleCheckboxChange = (id) => {
    const newIsActive = !isCheckedMap[id]; // Toggle boolean
    const statusValue = newIsActive ? 1 : 0; // Convert to 1 or 0
    setIsCheckedMap((prev) => ({
      ...prev,
      [id]: newIsActive,
    }));

    JobIn_ActiveMutation.mutate({
      job_id: id,
      is_active: statusValue,
    });
  };

  const colCount = title?.length;
  const gridStyle = {
    gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
  };

  return {
    colCount,
    gridStyle,
    navigate,
    isCheckedMap,
    handleCheckboxChange,
    dispatch,
  };
};
